import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=be27cebc&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
import style0 from "./Radio.vue?vue&type=style&index=0&id=be27cebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be27cebc",
  null
  
)

export default component.exports